import { proxy } from "valtio";

type selfAssemblyInputStateType = {
  heightInput: string;
  widthInput: string[];
};

export const selfAssemblyInputState = proxy<selfAssemblyInputStateType>({
  heightInput: "",
  widthInput: [],
});

export const setSelfAssemblyHeightInput = (height: string) => {
  selfAssemblyInputState.heightInput = height;
};

export const setSelfAssemblyWidthInput = (width: string, index: number = 0) => {
  selfAssemblyInputState.widthInput[index] = width;
};

export const setSelfAssemblyWidthInputs = (widths: string[]) => {
  selfAssemblyInputState.widthInput = widths;
};

export const resetSelfAssemblyInputs = () => {
  selfAssemblyInputState.heightInput = "";
  selfAssemblyInputState.widthInput = [];
};
